<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";

export default {
    name: 'Title_Supplier',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {
            entityName: 'Supplier',
        };
    },

    methods: {},

    computed: {
        icon() {
            return "$supplier";
        },

        text() {
            if (this.loading || !this.item) {
                return this.$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: this.$t('servicesystem.common_objects.supplier.supplier') });
            }
            else {
                return `${this.item.Name}`;
            }
        },

        item() {
            return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
        },

        loading() {
            return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>